export function buildRecordFromKeyList(keyList, buildValue) {
    return Object.fromEntries(keyList.map((key) => [key, buildValue(key)]));
}
